<template>
  <div class="contact-page">
    <!-- Header导航栏（复用首页样式） -->
    <header class="website-header" :class="{ 'scrolled': isScrolled }">
      <div class="header-container">
        <div class="logo-section" @click="goToHomepage" style="cursor: pointer;">
          <img src="@/assets/logo/logo.png" alt="小虫单" class="logo-img" />
          <span class="logo-text">小虫单</span>
        </div>
        
        <nav class="nav-menu">
          <a href="#home" class="nav-link" @click.prevent="goToHomepage">首页</a>
          <a href="#product-functions" class="nav-link" @click.prevent="goToHomepage">产品功能</a>
          <a href="#pricing" class="nav-link" @click.prevent="goToHomepage">版本价格</a>
          <a href="#about" class="nav-link" @click.prevent="goToHomepage">关于我们</a>
        </nav>
        
        <div class="header-actions">
          <el-button type="text" class="action-btn" @click="handleLogin">登录/注册</el-button>
          <el-button type="text" class="download-header-btn" @click="handleDownload">下载小虫单</el-button>
          <el-button type="warning" class="contact-header-btn" @click="handleContact">联系销售</el-button>
        </div>
      </div>
      
      <!-- Header横幅 -->
      <div class="header-banner">
        <div class="banner-content">
          <div class="banner-text-wrapper">
            <span class="banner-text banner-text-white">小虫单，真简单 | </span>
            <span class="banner-text banner-text-yellow">为中小型消杀企业量身打造的移动工单！</span>
            <el-button type="warning" class="banner-trial-btn" @click="handleTrial">免费试用 ></el-button>
          </div>
        </div>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <div class="contact-container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">联系我们</h1>
        <p class="page-subtitle">欢迎联系我们,小虫单顾问将为您提供全力支持</p>
      </div>

      <div class="contact-wrapper">
        <!-- 左侧品牌区域 -->
        <div class="brand-panel">
          <div class="brand-logo">
              <img 
                :src="logoImage" 
                alt="小虫单" 
                class="brand-logo-img"
                @error="handleImageError"
              />
          </div>
          <div class="brand-name">小虫单</div>
          <div class="brand-slogan">小虫单,真简单</div>
        </div>

        <!-- 右侧表单区域 -->
        <div class="form-panel">
          <el-form 
            :model="formData" 
            ref="elForm" 
            :rules="rules" 
            @submit.prevent="submitForm"
            class="contact-form"
            label-width="100px"
          >
            <el-form-item prop="name" label="姓名">
              <el-input
                v-model="formData.name"
                placeholder="请输入您的姓名"
                class="form-input"
              />
            </el-form-item>

            <el-form-item prop="phone" label="电话">
              <el-input
                v-model="formData.phone"
                placeholder="请输入您的电话号码"
                class="form-input"
              />
            </el-form-item>

            <el-form-item label="职位">
              <el-input
                v-model="formData.position"
                placeholder="请输入您的职位名称"
                class="form-input"
              />
            </el-form-item>

            <el-form-item label="企业名称">
              <el-input
                v-model="formData.enterpriseName"
                placeholder="请输入您的企业名称"
                class="form-input"
              />
            </el-form-item>

            <el-form-item label="企业规模">
              <el-select
                v-model="formData.scale"
                placeholder="请选择您的企业规模"
                class="form-select"
                style="width: 100%;"
              >
                <el-option label="1-10人" value="1" />
                <el-option label="11-50人" value="2" />
                <el-option label="51-200人" value="3" />
                <el-option label="201人以上" value="4" />
              </el-select>
            </el-form-item>

            <el-form-item label="留言">
              <el-input
                v-model="formData.message"
                type="textarea"
                :rows="4"
                placeholder="请输入您的留言"
                class="form-textarea"
              />
            </el-form-item>

            <el-form-item>
              <el-button
                type="warning"
                class="submit-button"
                :disabled="isSubmitting"
                @click="submitForm"
                :loading="isSubmitting"
              >
                {{ isSubmitting ? `请等待 ${countdown} 秒` : '提交' }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 下载二维码弹窗 -->
    <el-dialog
      :model-value="downloadDialogVisible"
      @update:model-value="handleDialogClose"
      title=""
      width="720px"
      :show-close="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      class="download-dialog"
      center
    >
      <div class="download-content">
        <h2 class="download-title">
          <span class="title-text-black">下载</span>
          <span class="title-text-blue">小虫单APP</span>
        </h2>
        <p class="download-desc">让智能管理赋能虫害防制,让企业更高效、更具竞争力!</p>
        <div class="qr-codes-row">
          <div 
            class="qr-card qr-card-android" 
            :class="{ 'is-revealed-tap': qrRevealedPlatform === 'android' }"
          >
            <div class="qr-card-reveal">
              <div class="qr-code-layer">
                <img 
                  src="@/assets/app.png" 
                  alt="安卓下载二维码" 
                  class="qr-code-image"
                  @error="handleQrCodeError"
                />
              </div>
              <div class="qr-mask-layer" @click="qrRevealedPlatform = 'android'">
                <img src="@/assets/Android.png" alt="安卓" class="qr-mask-icon" />
                <span class="qr-mask-label">Android 客户端</span>
                <span class="qr-mask-tip">悬停或点击显示二维码</span>
              </div>
            </div>
            <p class="qr-card-hint">扫码下载安卓版</p>
          </div>
          <div 
            class="qr-card qr-card-ios" 
            :class="{ 'is-revealed-tap': qrRevealedPlatform === 'ios' }"
          >
            <div class="qr-card-reveal">
              <div class="qr-code-layer">
                <img 
                  :src="iosQrSrc" 
                  alt="iOS下载二维码" 
                  class="qr-code-image"
                  @error="handleQrCodeError"
                />
              </div>
              <div class="qr-mask-layer" @click="qrRevealedPlatform = 'ios'">
                <img src="@/assets/Apple.png" alt="苹果" class="qr-mask-icon" />
                <span class="qr-mask-label">iOS & iPadOS 客户端</span>
                <span class="qr-mask-tip">悬停或点击显示二维码</span>
              </div>
            </div>
            <p class="qr-card-hint">扫码跳转 App Store</p>
          </div>
        </div>
        <p class="download-hint">悬停或点击对应卡片显示二维码,避免误扫; 使用手机浏览器扫一扫下载</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addUserRecord } from '@/api/contact'

export default {
  name: 'ContactPage',
  data() {
    return {
      isScrolled: false,
      logoImage: require('@/assets/logo/logo.png'),
      downloadDialogVisible: false,
      qrRevealedPlatform: null,
      formData: {
        name: '',
        phone: '',
        position: '',
        enterpriseName: '',
        scale: '',
        message: '',
        reception: '官网联系',
        channel: '1'
      },
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ]
      },
      isSubmitting: false,
      countdown: 5,
      countdownInterval: null
    }
  },
  computed: {
    qrCodeUrl() {
      const downloadLink = 'https://your-download-link.com'
      const encodedText = encodeURIComponent(downloadLink)
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodedText}`
    },
    iosQrSrc() {
      return require('@/assets/IOS App.png')
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    goToHomepage() {
      this.$router.push('/homepage')
    },
    handleLogin() {
      window.open('https://platform.xcdan.com/register', '_blank')
    },
    handleDownload() {
      this.qrRevealedPlatform = null
      this.downloadDialogVisible = true
    },
    handleDialogClose(value) {
      this.downloadDialogVisible = value
      if (!value) this.qrRevealedPlatform = null
    },
    handleQrCodeError(event) {
      // 二维码加载失败时的处理
      console.warn('二维码加载失败:', event.target.src)
      // 可以设置一个默认的二维码图片或重新生成
    },
    handleContact() {
      // 已经在联系页面，可以滚动到顶部或不做处理
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleTrial() {
      this.$message.info('免费试用功能开发中...')
    },
    handleImageError(event) {
      // 图片加载失败时的处理
      console.warn('图片加载失败:', event.target.src)
      // 尝试使用备用图片路径
      try {
        this.logoImage = require('@/assets/logo/pure-logo.png')
      } catch (e) {
        console.error('备用图片也加载失败:', e)
      }
    },
    async submitForm() {
      if (this.isSubmitting) return

      this.$refs.elForm.validate(async (valid) => {
        if (valid) {
          this.isSubmitting = true
          this.startCountdown()

          try {
            const res = await addUserRecord(this.formData)
            // axios返回的响应结构: res.status是HTTP状态码, res.data是响应数据
            if (res.status === 200 || res.data?.code === 200) {
              this.$message.success('提交成功！我们会在24小时内派专人联系您')
              // 重置表单
              this.formData = {
                name: '',
                phone: '',
                position: '',
                enterpriseName: '',
                scale: '',
                message: '',
                reception: '官网联系',
                channel: '1'
              }
              this.$refs.elForm.resetFields()
            } else {
              this.$message.error(res.data?.msg || '提交失败，请稍后再试！')
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('提交失败，请稍后再试！')
          } finally {
            // 确保倒计时结束后重置状态
            setTimeout(() => {
              if (this.countdown <= 0) {
                this.isSubmitting = false
              }
            }, this.countdown * 1000)
          }
        }
      })
    },
    startCountdown() {
      this.countdown = 5
      this.countdownInterval = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.countdownInterval)
          this.isSubmitting = false
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  min-height: 100vh;
  background: #f5f7fb;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

// Header样式（完全复用首页样式）
.website-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &.scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .header-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-banner {
    background: #1B5898;
    color: #fff;
    padding: 12px 0;

    .banner-content {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;

      .banner-text-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
      }

      .banner-text {
        font-size: 18px;
        font-weight: 500;
        line-height: 1.5;

        &.banner-text-white {
          color: #ffffff;
        }

        &.banner-text-yellow {
          color: #FFC133;
        }
      }

      .banner-trial-btn {
        background: #FFC133;
        border-color: #FFC133;
        color: #000;
        font-weight: 500;
        padding: 6px 16px;
        border-radius: 12px;
        transition: all 0.3s ease;
        flex-shrink: 0;

        &:hover {
          background: #ffb300;
          border-color: #ffb300;
        }
      }
    }
  }

  .logo-section {
    display: flex;
    align-items: center;
    gap: 12px;
    animation: fadeInLeft 0.6s ease;

    .logo-img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }

    .logo-text {
      font-size: 20px;
      font-weight: 600;
      color: #1B5898;
    }
  }

  .nav-menu {
    display: flex;
    gap: 40px;
    flex: 1;
    justify-content: center;

    .nav-link {
      color: #333;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      transition: color 0.3s ease;
      position: relative;

      &:hover {
        color: #1B5898;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 0;
        height: 2px;
        background: #1B5898;
        transition: width 0.3s ease;
      }

      &:hover::after {
        width: 100%;
      }
    }
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 20px;

    .contact-info {
      color: #666;
      font-size: 14px;
    }

    .action-btn {
      color: #333;
      font-size: 14px;
      padding: 0;
      transition: color 0.3s ease;

      &:hover {
        color: #1B5898;
      }
    }

    .download-header-btn {

      border-color: #1B5898;
      color:#1B5898;
      font-weight: 500;
      padding: 8px 20px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        background: #0A3563;
        border-color: #0A3563;
      }
    }

    .contact-header-btn {
      background: #FFC133;
      border-color: #FFC133;
      color: #000;
      font-weight: 500;
      padding: 8px 20px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        background: #ffb300;
        border-color: #ffb300;
      }
    }
  }
}

.contact-container {
  padding-top: 158px; // Header高度：导航栏70px + 横幅约44px + 间距
  min-height: calc(100vh - 158px);
  padding: 60px 40px;
  max-width: 1400px;
  margin: 0 auto;
  animation: fadeInUp 0.8s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

// 页面标题区域
.page-header {
  text-align: center;
  margin-bottom: 50px;
  animation: fadeInUp 0.8s ease;

  .page-title {
    font-size: 48px;
    font-weight: 700;
    color: #333;
    margin-bottom: 16px;
    line-height: 1.2;
  }

  .page-subtitle {
    font-size: 18px;
    color: #666;
    line-height: 1.6;
    margin: 0;
  }
}

.contact-wrapper {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 60px;
  align-items: center;
}

// 左侧品牌面板
.brand-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  animation: fadeInLeft 0.8s ease;
}

.brand-logo {
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeInUp 0.8s ease 0.2s both;

  .brand-logo-square {
    width: 120px;
    height: 120px;
    background: #1B5898;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(27, 88, 152, 0.2);
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  .brand-logo-img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    display: block;
    // 如果logo是白色或黑色，需要转换为金色，取消下面的注释
    // 如果logo本身已经是金色，保持注释状态
    // filter: brightness(0) saturate(100%) invert(77%) sepia(95%) saturate(1352%) hue-rotate(1deg) brightness(105%) contrast(105%);
  }
}

.brand-name {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
  animation: fadeInUp 0.8s ease 0.4s both;
}

.brand-slogan {
  font-size: 18px;
  color: #666;
  animation: fadeInUp 0.8s ease 0.6s both;
}

// 右侧表单面板（去掉卡片样式）
.form-panel {
  padding: 0;
  animation: fadeInRight 0.8s ease;
}

.contact-form {
  // 确保 Element Plus 表单正常布局
  :deep(.el-form-item) {
    margin-bottom: 24px;
  }

  :deep(.el-form-item__label) {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  .form-textarea {
    width: 100%;

    :deep(.el-textarea__inner) {
      border-radius: 8px;
      border: 1px solid #dcdfe6;
      padding: 12px 15px;
      font-size: 14px;
      transition: all 0.3s ease;
      resize: vertical;
      min-height: 100px;

      &:focus {
        border-color: #1B5898;
        box-shadow: 0 0 0 2px rgba(27, 88, 152, 0.1);
      }
    }
  }

  .submit-button {
    width: 50%;
    padding: 26px 14px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 24px;
    background: #FFC133;
    border-color: #FFC133;
    color: #000;
    transition: all 0.3s ease;
    animation: fadeInUp 0.6s ease 0.4s both;
    margin-left: auto;
    margin-right: auto;
    display: block;
    position: relative;

    :deep(span) {
      position: relative;
      top: -5px;
      display: inline-block;
    }

    &:hover:not(:disabled) {
      background: #ffb300;
      border-color: #ffb300;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(255, 193, 51, 0.3);
    }

    &:disabled {
      background: #ccc;
      border-color: #ccc;
      cursor: not-allowed;
      transform: none;
    }
  }
}

// 动画定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 响应式设计
@media (max-width: 968px) {
  .contact-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .brand-panel {
    order: 2;
  }

  .form-panel {
    order: 1;
  }

}

@media (max-width: 768px) {
  .contact-container {
    padding: 148px 20px 40px;
  }

  .page-header {
    margin-bottom: 30px;

    .page-title {
      font-size: 32px;
    }

    .page-subtitle {
      font-size: 16px;
    }
  }

  .form-panel {
    padding: 0;
  }

  .contact-form {
    :deep(.el-form-item) {
      flex-direction: column;

      :deep(.el-form-item__label) {
        width: 100% !important;
        line-height: 1.5;
        margin-bottom: 8px;
        padding-right: 0;
      }

      :deep(.el-form-item__content) {
        width: 100%;
      }
    }
  }

  .brand-panel {
    .brand-logo .brand-logo-square {
      width: 100px;
      height: 100px;
    }

    .brand-logo .brand-logo-img {
      width: 70px;
      height: 70px;
    }

    .brand-name {
      font-size: 28px;
    }

    .brand-slogan {
      font-size: 16px;
    }
  }

  .website-header {
    .header-container {
      padding: 0 20px;
      flex-wrap: wrap;
      height: auto;
      min-height: 70px;
    }

    .nav-menu {
      order: 3;
      width: 100%;
      justify-content: space-around;
      padding: 10px 0;
      gap: 15px;
      flex-wrap: wrap;

      .nav-link {
        font-size: 14px;
      }
    }

    .header-actions {
      flex-wrap: wrap;
      gap: 8px;
      order: 2;

      .contact-info {
        display: none;
      }

      .action-btn,
      .download-header-btn,
      .contact-header-btn {
        font-size: 12px;
        padding: 6px 12px;
      }
    }

    .header-banner {
      .banner-content {
        padding: 0 20px;
        flex-direction: column;
        gap: 12px;
        text-align: center;

        .banner-text {
          font-size: 14px;
        }

        .banner-trial-btn {
          padding: 6px 16px;
          font-size: 12px;
        }
      }
    }
  }
}

// 下载二维码弹窗样式
:deep(.download-dialog) {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
  }

  .el-dialog__header {
    padding: 0;
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__close {
    color: #333;
    font-size: 24px;
    z-index: 10;
    position: absolute;
    right: 20px;
    top: 20px;
    transition: all 0.3s ease;

    &:hover {
      color: #1B5898;
      transform: rotate(90deg);
    }
  }
}

.download-content {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
  padding: 60px 40px;
  text-align: center;
  animation: fadeInUp 0.6s ease;

  .download-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 1.5;

    .title-text-black {
      color: #000000;
    }

    .title-text-blue {
      color: #1B5898;
    }
  }

  .download-desc {
    font-size: 16px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 40px;
    padding: 0 20px;
  }

  .qr-codes-row {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 32px;
    margin-bottom: 28px;
    flex-wrap: wrap;
  }

  .qr-card {
    flex: 0 0 auto;
    width: 272px;
    background: #ffffff;
    border-radius: 20px;
    padding: 28px 24px;
    box-shadow: 0 4px 24px rgba(27, 88, 152, 0.06);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    animation: fadeInUp 0.5s ease both;
    border: 1px solid rgba(27, 88, 152, 0.08);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &.qr-card-android {
      animation-delay: 0.15s;

      &::before {
        background: linear-gradient(90deg, #3ddc84 0%, #2e7d32 100%);
      }
    }

    &.qr-card-ios {
      animation-delay: 0.25s;

      &::before {
        background: linear-gradient(90deg, #555 0%, #1d1d1f 100%);
      }
    }

    &:hover,
    &.is-revealed-tap {
      .qr-mask-layer {
        opacity: 0;
        pointer-events: none;
      }

      .qr-code-layer {
        opacity: 1;
      }
    }

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 16px 36px rgba(27, 88, 152, 0.12);
      border-color: rgba(27, 88, 152, 0.14);

      &::before {
        opacity: 1;
      }
    }

    .qr-card-reveal {
      position: relative;
      width: 200px;
      height: 240px;
      border-radius: 14px;
      overflow: hidden;
      background: #f8fafc;
    }

    .qr-code-layer {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      opacity: 0;
      transition: opacity 0.35s ease;

      .qr-code-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
    }

    .qr-mask-layer {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border-radius: 14px;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
      opacity: 1;
      transition: opacity 0.35s ease;
      cursor: pointer;
    }

    .qr-mask-icon {
      width: 56px;
      height: 56px;
      object-fit: contain;
      margin-bottom: 14px;
      flex-shrink: 0;
    }

    .qr-mask-label {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
      text-align: center;
      line-height: 1.4;
      padding: 0 8px;
    }

    .qr-mask-tip {
      font-size: 12px;
      color: #94a3b8;
      margin-top: 12px;
    }

    .qr-card-hint {
      font-size: 13px;
      color: #64748b;
      margin-top: 16px;
      margin-bottom: 0;
    }
  }

  .download-hint {
    font-size: 14px;
    color: #64748b;
    line-height: 1.6;
    margin: 0;
    animation: fadeInUp 0.6s ease 0.35s both;
  }
}

// 响应式设计
@media (max-width: 768px) {
  :deep(.download-dialog) {
    .el-dialog {
      width: 90% !important;
      margin: 5vh auto;
    }
  }

  .download-content {
    padding: 40px 20px;

    .download-title {
      font-size: 24px;
    }

    .download-desc {
      font-size: 14px;
      margin-bottom: 30px;
    }

    .qr-codes-row {
      flex-direction: column;
      gap: 24px;
    }

    .qr-card {
      width: 100%;
      max-width: 280px;
      margin: 0 auto;

      .qr-card-reveal {
        width: 200px;
        height: 240px;
      }
    }

    .download-hint {
      font-size: 13px;
    }
  }
}
</style>

